export default "__VITE_ASSET__CenMuk_r__"